import request from '@/utils/request'

// 查询作品管理列表
export function listWorks(query) {
  return request({
    url: '/OmdWorks/works/list',
    method: 'get',
    params: query
  })
}


// 查询作品管理列表
export function listluss(query) {
  return request({
    url: '/OmdWorks/works/listluss',
    method: 'get',
    params: query
  })
}


//学生查询自己的所有作品
export function listStudentWorksByUserID(query) {
  return request({
    url: '/OmdWorks/works/listByStudent',
    method: 'get',
    params: query
  })
}

//学生查询自己的所有作品
export function listByTecher(query) {
  return request({
    url: '/OmdWorks/works/listByTecher',
    method: 'get',
    params: query
  })
}

// 查询作品管理详细
export function getWorks(id) {
  return request({
    url: '/OmdWorks/works/' + id,
    method: 'get'
  })
}
// 新增作品管理
export function addWorks(data) {
  return request({
    url: '/Works/works',
    method: 'post',
    data: data
  })
}

// 修改作品管理
export function updateWorks(data) {
  return request({
    url: '/OmdWorks/works',
    method: 'put',
    data: data
  })
}

// 删除作品管理
export function delWorks(id) {
  return request({
    url: '/OmdWorks/works/' + id,
    method: 'delete'
  })
}
export function delWorkss(id) {
  return request({
    url: '/Works/works/' + id,
    method: 'delete'
  })
}
